const primaryScale = {
  50: '#F5F5F5',
  100: '#EBEBEB',
  200: '#D6D6D6',
  300: '#B8B8B8',
  400: '#5D5D5D',
  500: '#333333',
  600: '#292929',
  700: '#1F1F1F',
  800: '#141414',
  900: '#0A0A0A',
};

export const colors = {
  surface: {
    canvas: '#FAFAFA',
    base: '#FFFFFF',
    raised: '#FFFFFF',
    frame: 'rgba(245, 245, 245, 0.4)',
    selected: '#F5F5F5',
    sidebar: '#FAFAFA',
    sidebarSelected: '#EDEDED',
  },

  content: {
    strong: '#292929',
    body: '#5D5D5D',
    subtle: '#7F7F7F',
    faint: '#9E9E9E',
    inverse: '#FFFFFF',
  },

  line: {
    hairline: '#F2F2F2',
    input: '#EBEBEB',
    ring: '#C9C9C9',
  },

  state: {
    link: '#1391C9',
    linkSurface: '#E8F6FC',
    success: '#15B042',
    successSurface: '#CAFACE',
    warning: '#D9772E',
    warningSurface: '#F9EDE7',
    destructive: '#D63D3D',
    destructiveSurface: '#FBEAEA',
    toggle: '#1391C9',
  },

  brand: {
    navy: '#123F62',
    blue: '#2AABE2',
    orange: '#F07E26',
    50: '#E8F6FC',
    100: '#C6E9F7',
    200: '#93D6F0',
    300: '#5FC2E9',
    400: '#2AABE2',
    500: '#1391C9',
    600: '#0F76A3',
    700: '#0B5A7C',
    800: '#083F56',
    900: '#04232F',
  },

  blue: {
    50: '#E8F6FC',
    100: '#C6E9F7',
    200: '#93D6F0',
    300: '#5FC2E9',
    400: '#2AABE2',
    500: '#1391C9',
    600: '#0F76A3',
    700: '#0B5A7C',
    800: '#083F56',
    900: '#04232F',
  },

  green: {
    50: '#EAF9EE',
    100: '#CAFACE',
    200: '#9CE8AB',
    300: '#6BD684',
    400: '#3CC462',
    500: '#15B042',
    600: '#118F36',
    700: '#0D6E29',
    800: '#094D1D',
    900: '#052C10',
  },

  red: {
    50: '#FBEAEA',
    100: '#F6CFCF',
    200: '#EDA6A6',
    300: '#E37D7D',
    400: '#DA5B5B',
    500: '#D63D3D',
    600: '#B32F2F',
    700: '#8A2424',
    800: '#611919',
    900: '#380E0E',
  },

  orange: {
    50: '#F9EDE7',
    100: '#F3D8CB',
    200: '#E9B79E',
    300: '#E29A75',
    400: '#DE854D',
    500: '#D9772E',
    600: '#B66026',
    700: '#8C4A1D',
    800: '#623414',
    900: '#381E0C',
  },

  theme: {
    light: {
      body: '#FAFAFA',
      bodySecondary: '#FFFFFF',
      primary: '#292929',
      secondary: '#5D5D5D',
      tertiary: '#333333',
    },
    dark: {
      body: '#141414',
      primary: '#EDEDED',
      secondary: '#A8A8A8',
      tertiary: '#EDEDED',
    },
  },

  button: {
    primary: primaryScale,
  },

  text: {
    light: {
      primary: '#292929',
      secondary: '#1391C9',
      tertiary: '#FFFFFF',
      divider: '#F2F2F2',
    },
    dark: {
      primary: '#EDEDED',
      secondary: '#4AA8FF',
    },
  },
};
